
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';
import TagIcon from '@components/shared/icons/TagIcon.vue';
import LetterIcon from '@components/shared/icons/LetterIcon.vue';

export interface IconProps {
  value?: string,
  fill?: string,
  color?: string,
  position?: number,
  fillId?: string,
}

@Component({
  name: 'OeamtcIcon',
  components: {
    CircleIcon,
    TagIcon,
    LetterIcon
  }
})
export default class OeamtcIcon extends Vue {
  @Prop()
  private tagIcon: IconProps;

  @Prop()
  private letterIcon: IconProps;

  @Prop({ default: 40 })
  private size: number;

  created() {
    if (!this.tagIcon && !this.letterIcon) {
      throw Error('tagIcon or letterIcon prop expected');
    }
  }

  get defaultIcon() {
    return 'tag_default_icon';
  }

  get defaultColor() {
    return '#ffdc00';
  }

  get defaultFill() {
    return '#000';
  }
}
